import { render, staticRenderFns } from "./VFiltro.vue?vue&type=template&id=6cbc84a2"
var script = {}
import style0 from "./VFiltro.vue?vue&type=style&index=0&id=6cbc84a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports